import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import './index.scss'
import {message, Modal} from 'antd'
import { pgHandler,pgEditHandler} from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import { Form, Input } from 'antd';
import CButton from '@/components/CButton'

@CBaseComponent
class ProcessManagement extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.modalOk = this.modalOk.bind(this);
    this.modalCancel = this.modalCancel.bind(this);
    this.onClick = this.onClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
      title:'',
      visible:false,
      titles:'',
      steps:[],
      tips:'',
      id:''
  };

  onClick(data,id){
    this.setState({
      visible: true,
      tips:data,
      id:id
    })
  }

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    pgHandler().then(res=>{
      if (res.statecode === 0) {
        let dialog = -1
        res.records.forEach((item,index)=>{
          item.alerts = false
          if (item.current === 'y') {
            dialog = index +1
            this.setState({
              titles:item.name
            })
          }
        })
        res.records[dialog].alerts = true
        this.setState({
          steps:res.records
        })
      }  else {
        message.error(res.statemessage)
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  modalOk(){
    const params = {
      id:this.state.id
    }
    pgEditHandler(params).then(res=>{
      message.success('编辑成功');
      this.modalCancel()
    })
  }

  modalCancel(){
    this.setState({
      visible: false,
      tips: '',
      id:''
    })
  }


  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <h3>
            博物馆运行评估当前阶段处于：{this.state.titles}
          </h3>
          <div style={{display:'flex',margin:'30px auto'}}>
            {
              this.state.steps.map((item,index)=>{
                if (item.current === 'y') {
                 return (
                     <div>
                       <CButton type='primary'>{item.name}</CButton>
                       {index === 3 ? '' :<span style={{fontSize:'20px',margin:'0 30px'}}>-></span>}
                     </div>
                 )
                } else {
                  if (item.alerts) {
                    return (
                        <div>
                          <CButton onClick={()=>{this.onClick(item.tips,item.id)}}>{item.name}</CButton>
                          {index === 3 ? '' :<span style={{fontSize:'20px',margin:'0 30px'}}>-></span>}
                        </div>
                    )
                  } else {
                    return (
                        <div>
                          <CButton>{item.name}</CButton>
                          {index === 3 ? '' :<span style={{fontSize:'20px',margin:'0 30px'}}>-></span>}
                        </div>
                    )
                  }
                }
              })
            }
          </div>
          <Modal
              title={this.state.title}
              visible={this.state.visible}
              onOk={this.modalOk}
              onCancel={this.modalCancel}
              closable={false}
          >
            <div style={{fontSize:'18px',color:'orange'}}>
              {this.state.tips}
            </div>
          </Modal>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ProcessManagement);
